import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GraduationCap, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      toast.success(`¡Bienvenido, ${data.name}!`);
      navigate(data.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#050505] grid-bg flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-md bg-[#00E5FF] flex items-center justify-center"><GraduationCap className="w-6 h-6 text-black" /></div>
          <span className="font-heading font-bold text-xl">Capacita<span className="text-[#00E5FF]">Pro</span></span>
        </Link>
        <div className="bg-[#0C0D12] border border-white/10 rounded-xl p-8">
          <h1 className="font-heading font-bold text-2xl mb-1">Bienvenido de vuelta</h1>
          <p className="font-body text-sm text-[#8A8D98] mb-6">Ingresa para continuar aprendiendo</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="font-body text-sm text-[#8A8D98] mb-2 block">Correo</Label>
              <Input data-testid="login-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="bg-[#13141C] border-white/10 rounded-md focus:border-[#00E5FF] focus-visible:ring-1 focus-visible:ring-[#00E5FF] text-white h-11" />
            </div>
            <div>
              <Label className="font-body text-sm text-[#8A8D98] mb-2 block">Contraseña</Label>
              <Input data-testid="login-password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="bg-[#13141C] border-white/10 rounded-md focus:border-[#00E5FF] focus-visible:ring-1 focus-visible:ring-[#00E5FF] text-white h-11" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full bg-[#00E5FF] text-black font-semibold hover:bg-white rounded-md h-12">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Ingresar"}
            </Button>
          </form>
          <p className="font-body text-sm text-[#8A8D98] text-center mt-6">¿No tienes cuenta? <Link to="/register" className="text-[#00E5FF] hover:underline">Regístrate</Link></p>
        </div>
      </div>
    </div>
  );
}
